import Swiper from 'swiper';
import { Navigation, A11y, FreeMode } from 'swiper/modules';
import { animate } from '../../core/animations';
import sliderADA from '../../components/slider/ada';

// Doesn't look great on product lists
/*
const keepContentSameHeight = ($slider) => {
  let max_title_height = 0;
  _.each($slider.find('[data-product-tile]'), tile => {
    const tile_height = $(tile).find('[data-product-tile-title]').height();
    if (tile_height > max_title_height) {
      max_title_height = tile_height;
    }
  });

  _.each($slider.find('[data-product-tile]'), tile => {
    $(tile).find('[data-product-tile-title]').height(max_title_height);
  });
};
*/

const initSlider = (slider) => {
  // const is_nosto_slider = slider.classList.contains('nosto_element');
  return new Promise((resolve) => {
    // if (slider.classList.contains('swiper-initialized')) {
    //   resolve();
    //   return;
    // }

    let slides_to_show_desktop = 5;
    let slides_spacing_desktop = 20;

    const nosto_parent_container = slider.closest('[data-nosto-recommendations]');
    if (nosto_parent_container !== null) {
      slides_to_show_desktop = Number(nosto_parent_container.dataset.totalSlidesDesktop) || 5;
      slides_spacing_desktop = Number(nosto_parent_container.dataset.spacingSlidesDesktop) || 20;

      const recommended_product_page = nosto_parent_container.dataset.recommendedProductsPage;
      if ((typeof recommended_product_page !== 'undefined' && recommended_product_page !== 'OTHER') || document.querySelector('body').classList.contains('template-plp')) {
        slides_to_show_desktop += 0.5;
      }
    }

    const section_id = slider.closest('section').id;


    // Important: We reinject html into the swiper element due to the PDP where the product list needs to be refreshed on variant change
    // This involves manually re-adding the swiper wrapper and elements such as navigation
    // See populateSingleSection() from recommendation-lists.js for more details
    new Swiper(`#${section_id} .swiper`, {
      modules: [ Navigation, A11y, FreeMode ], // https://swiperjs.com/swiper-api#using-js-modules
      a11y: {
        enabled: true,
        prevSlideMessage: window.theme.strings.swiperPrevSlide,
        nextSlideMessage: window.theme.strings.swiperNextSlide,
        containerMessage: window.theme.strings.swiperContainer,
      },
      slidesPerView: 2.3,
      slidesPerGroup: 1,
      spaceBetween: 20,
      loop: true,
      loopAddBlankSlides: false,
      // autoHeight: true, // doesn't seem to work well with cssMode
      freeMode: true,
      autoplay: false,
      cssMode: nosto_parent_container?.dataset.swiperCssMode === 'true' || false, // https://swiperjs.com/swiper-api#param-cssMode
      // navigation: false,
      breakpoints: {
        769: {
          slidesPerView: slides_to_show_desktop,
          slidesPerGroup: slides_to_show_desktop,
          spaceBetween: slides_spacing_desktop,
          freeMode: false,
          navigation: {
            nextEl: `#${section_id} .swiper-button-next`,
            prevEl: `#${section_id} .swiper-button-prev`,
          },
        },
      },
      on: {
        init: function () {
          animate();
          resolve();
          sliderADA(slider);
          // keepContentSameHeight($(slider));
        },
      }
    });
  });
};

/*
list_types: any, nosto, shopify
*/
export default (list_types = 'any') => {
  const nosto_sliders = document.querySelectorAll('[data-nosto-recommendations] .swiper');
  const shopify_sliders = document.querySelectorAll('[data-shopify-products-list] .swiper');
  
  let sliders = [];
  if (typeof nosto_sliders !== 'undefined' && (list_types === 'any' || list_types === 'nosto')) {
    sliders = [...sliders, ...nosto_sliders];
  }

  if (typeof shopify_sliders !== 'undefined' && (list_types === 'any' || list_types === 'shopify')) {
    sliders = [...sliders, ...shopify_sliders];
  }

  if (!sliders.length) {
    return;
  }

  sliders.forEach(slider => {
    initSlider(slider);
  });
};
